import { isSupportedStateCode } from '@/common/constants/states';
import type { LeaseRepresentation } from '@/common/types/interaction';
import type { MissingFieldsData } from '@/state/navigation';
import { computeMissingLeaseContactFields } from './lease/missingFields';
import { computeMissingListingContactFields } from './listing/missingFields';
import {
  buildOfferContactsConfig,
  resolveOfferContactsConfig,
} from './offer/formConfig';
import { computeMissingOfferContactFields } from './offer/missingFields';
import type { ContactsFormData } from './shared/types';

export function computeContactMissingFields(
  formData: ContactsFormData,
  interactionType: string,
  rawState: string | null | undefined,
  representation: LeaseRepresentation | null | undefined,
): MissingFieldsData[] {
  if (interactionType === 'listing') {
    return computeMissingListingContactFields(formData);
  }
  if (interactionType === 'lease') {
    return computeMissingLeaseContactFields(formData, representation ?? 'dual');
  }
  const config = isSupportedStateCode(rawState)
    ? resolveOfferContactsConfig(rawState)
    : buildOfferContactsConfig();
  return computeMissingOfferContactFields(formData, config);
}
